var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bf-flex',{staticClass:"centered",attrs:{"id":"v-hash"}},[_c('h1',[_vm._v("d3fc3945cee832d1a5a87b70b6c34611d6b7bc34")])])}
var staticRenderFns = []

export { render, staticRenderFns }